<ng-template [ngIf]="!loading"
	[ngIfElse]= "loadingDisplay">
	<div class="text-display-container ui-g-12">
		<ng-template [ngIf]="field.props.usePanelDisplay"
			[ngIfElse]= "useDiv">
			<div class="accordion-content"
				[ngClass]="{
					'text-center': (field.props.centerText === true)
				}">
				<p-accordion *ngIf= "field.props.usePanelDisplay">
					<p-accordionTab header="{{field.props.title}}"
						[selected]="field.props.expanded">
						<ng-template [ngIf]="hasContent() && (field.props.useMarkdown || field.props.useCodeBlock)"
							[ngIfElse]= "useText">
							<span *ngIf="field.props.copyToClipboard && content !== '' && content != null"
								class="copy-to-clipboard"
								(click)="copyToClipboard(content)">
								<i *ngIf="!copiedToClipboard"
									class="pi pi-copy theme-color float-right">
								</i>
								<span *ngIf="copiedToClipboard"
									class="fade-out">
									<span class="float-right">
										&nbsp; Copied!
									</span>
									<i class="pi pi-check float-right">
									</i>
								</span>
							</span>
							<markdown [data]="content">
							</markdown>
						</ng-template>

						<ng-template #useText>
							<span *ngIf="field.props.copyToClipboard && content !== '' && content != null"
								class="copy-to-clipboard"
								(click)="copyToClipboard(content)">
								<i *ngIf="!copiedToClipboard"
									class="pi pi-copy theme-color float-right">
								</i>
								<span *ngIf="copiedToClipboard"
									class="fade-out">
									<span class="float-right">
										&nbsp; Copied!
									</span>
									<i class="pi pi-check float-right">
									</i>
								</span>
							</span>
							<p [innerHtml]="content">
							</p>
						</ng-template>
					</p-accordionTab>
				</p-accordion>

			</div>
		</ng-template>

		<ng-template #useDiv>
			<div class="text-content"
				[ngClass]="{
					'text-center': (field.props.centerText === true)
				}">
				<ng-template [ngIf]="hasContent() && (field.props.useMarkdown || field.props.useCodeBlock)"
					[ngIfElse]= "useText">
					<span *ngIf="field.props.copyToClipboard && content !== '' && content != null"
						class="copy-to-clipboard"
						(click)="copyToClipboard(content)">
						<i *ngIf="!copiedToClipboard"
							class="pi pi-copy theme-color float-right">
						</i>
						<span *ngIf="copiedToClipboard"
							class="fade-out">
							<span class="float-right">
								&nbsp; Copied!
							</span>
							<i class="pi pi-check float-right">
							</i>
						</span>
					</span>
					<markdown [data]="content">
					</markdown>
				</ng-template>

				<ng-template #useText>
					<span *ngIf="field.props.copyToClipboard && content !== '' && content != null"
						class="copy-to-clipboard"
						(click)="copyToClipboard(content)">
						<i *ngIf="!copiedToClipboard"
							class="pi pi-copy theme-color float-right">
						</i>
						<span *ngIf="copiedToClipboard"
							class="fade-out">
							<span class="float-right">
								&nbsp; Copied!
							</span>
							<i class="pi pi-check float-right">
							</i>
						</span>
					</span>
					<h2>
						{{field.props.title}}
					</h2>
					<p [innerHtml]="content">
					</p>
				</ng-template>
			</div>
		</ng-template>
	</div>
</ng-template>

<ng-template #loadingDisplay>
	<div class="text-center ui-g-12">
		<span class="fa fa-fw fa-spin fa-spinner theme-color double-font-size">
		</span>
	</div>
</ng-template>